/** @module Enums */ /** typedoc */
var UnavailabilityEnum;
(function (UnavailabilityEnum) {
    UnavailabilityEnum["Default"] = "Default";
    UnavailabilityEnum["FileIsUnderMinimumDuration"] = "FileIsUnderMinimumDuration";
    UnavailabilityEnum["FileIsOverMaximumDuration"] = "FileIsOverMaximumDuration";
    UnavailabilityEnum["OverCompressed"] = "OverCompressed";
    UnavailabilityEnum["FeatureNotSupported"] = "FeatureNotSupported";
    UnavailabilityEnum["Unauthorized"] = "Unauthorized";
    UnavailabilityEnum["AlreadyMastered"] = "AlreadyMastered";
    UnavailabilityEnum["CurrentlyMastering"] = "CurrentlyMastering";
    UnavailabilityEnum["ExternalTrackNotFound"] = "ExternalTrackNotFound";
    UnavailabilityEnum["ExternalAccountNotValidated"] = "ExternalAccountNotValidated";
    UnavailabilityEnum["FileIsOverMaximumSize"] = "FileIsOverMaximumSize";
    UnavailabilityEnum["ExternalAccountOutOfMinutes"] = "ExternalAccountOutOfMinutes";
    UnavailabilityEnum["UnavailableForRelease"] = "UnavailableForRelease";
})(UnavailabilityEnum || (UnavailabilityEnum = {}));

export { UnavailabilityEnum };
